module.exports = __webpack_public_path__ + "img/tooFacedPal2.f3e0be4d.jpg";